import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { stoageGetter } from "../../helpers";

const logindata = stoageGetter("user");
let id = "";
if (logindata) {
  id = logindata.id;
}

const initialState = {
  formData:{
    errorMessage: "",
  biDataloading: false,
  editBIError: "",
  editBILoading: false,
//   FullName: "",
//   productName: "",
//   MobileNo: "",
//   proposalStatus: "",
//   leadStatus: "",
//   userId: id,
//   lead_Owner_Id: "", //get from store
//   lead_Creator_Id: "", //get from store
//   leadId: "",
//   productId: "",
//   riders: [],
//   funds: [],
//   inputPartialWithdrawal: [],
//   formInputs: [
//     { key: "@DATEOF_COMMENCEMENT", value: "" },
//     { key: "@LI=PI", value: false },
//     { key: "@LI_NAME", value: "" },
//     { key: "@LI_DOB", value: "" },
//     { key: "@LI_ENTRY_AGE", value: "" },
//     { key: "@PROPOSER_NAME", value: "" },
//     { key: "@PROPOSER_DOB", value: "" },
//     { key: "@PROPOSER_AGE", value: "" },
//     { key: "@LI_GENDER", value: "" },
//     { key: "@PR_PT", value: "" },
//     { key: "@PR_PPT", value: "" },
//     { key: "@LI_Single/Limited", value: "" },
//     { key: "@INPUT_MODE", value: "" },
//     { key: "@PR_ANNPREM", value: 0 },
//     { key: "@LI_InstallmentPremium", value: "" },
//     { key: "@LI_AGEDEATHSUMASSURED", value: 0 },
//     { key: "@PR_MATURITYSUMASSURED", value: 0 },
//     { key: "@EMR_RATE", value: "" },
//     { key: "@RPM", value: "" },
//     { key: "@PR_ID", value: "" },
//   ],
  }
};

//bi fetched
const fetchProposalDetails = (state,action)=>{
    return updateObject(state, {
        formData: action.formData,
    });
}

//bi update start reducer

const editProposalDetailsStarted = (state) => {
  return updateObject(state, {
    editBILoading: true,
  });
};

//bi update success

const editProposalDetailsSuccess = (state,action)=>{
    const payload = { ...state.formData, ...action.formData };
    return updateObject(state,{
        editBiLoading: false,
        formData: payload,
    })
}

const editProposalDetailsFail = (state, action) => {
  return updateObject(state, {
    editBIError: action.error,
    biDataloading: false,
    errorMessage: action.error,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // lead
    case actionTypes.FETCH_PROPOSAL_DETAILS:
        return fetchProposalDetails(state,action);
    case actionTypes.FETCH_PROPOSAL_DETAILS_START:
      return editProposalDetailsStarted(state, action);
      case actionTypes.FETCH_PROPOSAL_DETAILS_SUCESS:
        return editProposalDetailsSuccess(state, action);  
    case actionTypes.FETCH_PROPOSAL_DETAILS_FAIL:
        return editProposalDetailsFail(state,action)
    case actionTypes.TRIGGER_OPPORTUNITY_API_START:
      return updateObject(state, {
        opportunityApiLoading: true,
        opportunityApiError: null,
      });
    case actionTypes.TRIGGER_OPPORTUNITY_API_SUCCESS:
      return updateObject(state, {
        opportunityApiLoading: false,
        opportunityApiSuccess: true,
        opportunityApiData: action.response,
      });
    case actionTypes.TRIGGER_OPPORTUNITY_API_FAIL:
      return updateObject(state, {
        opportunityApiLoading: false,
        opportunityApiError: action.error,
      });
    default:
      return state;
  }
};

export default reducer;
